import { createRouter, createWebHistory, type RouteRecordRaw } from 'vue-router'

const routes: RouteRecordRaw[] = [
  {
    path: '/',
    name: 'home',
    component: () => import('@/views/HomeView.vue'),
  },
  {
    path: '/imprint',
    name: 'imprint',
    component: () => import('@/views/ImprintView.vue'),
  },
  {
    path: '/privacy',
    name: 'privacy',
    component: () => import('@/views/PrivacyView.vue'),
  },
  // Legacy German URLs redirect to English routes for SEO/back-compat
  { path: '/impressum', redirect: '/imprint' },
  { path: '/impressum.html', redirect: '/imprint' },
  { path: '/datenschutz', redirect: '/privacy' },
  { path: '/datenschutz.html', redirect: '/privacy' },
  { path: '/:pathMatch(.*)*', redirect: '/' },
]

export const router = createRouter({
  history: createWebHistory(),
  routes,
  scrollBehavior(to, _from, savedPosition) {
    if (savedPosition) return savedPosition
    if (to.hash) {
      return new Promise((resolve) => {
        setTimeout(() => {
          const el = document.querySelector(to.hash)
          if (el) {
            const offset = (document.querySelector('nav.scrolled') ? 64 : 96) + 12
            const top = el.getBoundingClientRect().top + window.scrollY - offset
            resolve({ top, behavior: 'smooth' })
          } else {
            resolve({ top: 0 })
          }
        }, 50)
      })
    }
    return { top: 0 }
  },
})
